import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from '@nosto/preact';
import { sortOptions } from '../config';
import Icon from './elements/Icon';
import Select from './elements/Select';

function ToggleMobileSidebarButton({
  lableFor,
  selectedFiltersCount,
  className,
}) {
  return (
    <label
      for={lableFor}
      className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
    >
      <Icon name="filter" />
      <span>Filter</span>
      {selectedFiltersCount > 0 && (
        <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
          {selectedFiltersCount}
        </span>
      )}
    </label>
  );
}

export default function Sort({ lableFor }) {
  const { loading } = useAppState();
  const { activeSort, setSort } = useSort(sortOptions);
  const selectedFiltersCount = useSelectedFiltersCount();

  const handleSortChange = (event) => {
    setSort(event.target.value);
  };

  const options = sortOptions.map((o) => ({
    value: o.id,
    label: o.value.name,
  }));

  return (
    <Select
      value={activeSort}
      onChange={(e) => handleSortChange(e)}
      className="ns-selection-dropdown-sort-menu"
      options={options}
    />
  );
}
